import React                 from 'react';
import Tooltip               from '@widesk-ui/components/Tooltip';
import { BgColorsOutlined }  from '@ant-design/icons';
import useDesignTokens       from '@/hooks/useDesignTokens';
import leftSidebarStore      from '@/TokamapEditor/stores/leftSidebarStore';
import type { ThemeLockRef } from '@/TokamapEditor/helpers/themeImposed';

const ToolbarToggle = ({ label, active, onClick, lockedBy, children }: {
	label: string;
	active: boolean;
	onClick: () => void;
	lockedBy?: ThemeLockRef;
	children: React.ReactNode;
}) => {
	const tokens = useDesignTokens();

	return (
		<Tooltip title={lockedBy ? (lockedBy.target ? `${label} : imposé par le thème « ${lockedBy.theme} », cliquer pour le régler dans le thème` : `${label} : imposé par ${lockedBy.theme}`) : label}>
			<button
				type="button"
				aria-label={label}
				aria-pressed={active}
				aria-disabled={!!lockedBy}
				onClick={lockedBy ? () => leftSidebarStore.openThemeField(lockedBy.target) : onClick}
				style={{
					position: 'relative',
					width: 40,
					height: 40,
					borderRadius: 8,
					cursor: lockedBy && !lockedBy.target ? 'not-allowed' : 'pointer',
					opacity: lockedBy ? 0.5 : 1,
					fontSize: 15,
					color: active ? tokens.color.primary : tokens.text.default,
					border: `1px solid ${active ? tokens.color.primary : tokens.border.default}`,
					background: active ? `color-mix(in srgb, ${tokens.color.primary} 10%, transparent)` : tokens.surface.elevated,
				}}
			>
				{children}
				{!!lockedBy && (
					<BgColorsOutlined style={{ position: 'absolute', top: 3, right: 3, fontSize: 9, color: tokens.color.primary }} />
				)}
			</button>
		</Tooltip>
	);
};

export default ToolbarToggle;
